import { ArrowUpRight, Lock, ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  const navigate = useNavigate();
  return (
    <header className="nav">
      <div className="container nav-inner">
        <a href="#" className="brand" onClick={(e) => e.preventDefault()}>
          <span className="brand-mark"><ShieldCheck size={14} strokeWidth={1.5} /></span>
          QXAI<span style={{ color: "var(--fg-faint)" }}>.SPACE</span>
        </a>
        <nav className="nav-links">
          <a href="#guarantees">Guarantees</a>
          <a href="#architecture">Architecture</a>
          <a href="#how">How it works</a>
          <a href="#cta">Get started</a>
        </nav>
        <div className="nav-cta">
          <button
            onClick={() => navigate('/signin')}
            className="btn"
            style={{ padding: "10px 16px" }}
          >
            <span>Sign in</span>
          </button>
          <button
            onClick={() => navigate('/signup')}
            className="btn btn-primary"
            style={{ padding: "10px 16px" }}
          >
            <Lock size={12} strokeWidth={1.5} />
            <span>Get started</span>
            <ArrowUpRight size={14} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </header>
  );
}
